module.exports = __webpack_public_path__ + "static/media/contacts-on.fdb00c89.svg";